<template src="./index.html"></template>
<style src="./style.scss" lang="scss" scoped></style>
<script>
import { mapGetters } from 'vuex';

import Navbar from '@/components/Navbar';
import ProgressBar from '@/components/ProgressBar';
import BackButton from '@/components/BackButton';
 import CustomButton from '@/components/CustomButton';
import Background from '@/components/Background';
import TextFlowNumber from '@/components/TextFlowNumber';
import CallFlowDropdown from './CallFlowDropdown';
import { ROUTE_TYPES } from '@/constants';
import { M_SET_TEXT_FLOW_TO_PERSON, M_ONBOARDING_STEP } from '@/graphql';

export default {
  name: 'TextRoutePerson',
  components: {
    Navbar,
    ProgressBar,
    BackButton,
    CustomButton,
    Background,
    TextFlowNumber,
    CallFlowDropdown
  },
  data() {
    return {
          isLoading: false,
      selectedPerson: null,
      isText: false,
      selectedgroup: null,
      type: "",
    };
  },
  computed: {
    ...mapGetters({
            users: 'auth/getUsers',
   
   
         contacts: 'conversation/getContacts',

      user: 'auth/getUser',
      groups: 'auth/getUserGroups',
      fullTeam: 'auth/getUserFullTeam',
      phoneName: 'onboarding/getSelectedName',
      phoneNumber: 'onboarding/getSelectedNumber',
      phoneId: 'onboarding/getSelectedId',
      textFlow: 'onboarding/getSelectedTextFlow'
    })
  },
  mounted() {
    
  
    

 
    if (this.textFlow && this.textFlow.type === ROUTE_TYPES.ROUTE_PERSON) {
      this.selectedPerson = this.fullTeam.find((user) => user.id === this.textFlow.toPerson.id);
         this.type = "person"   
   
   
   
      this.$emit('setsUsers', this.selectedPerson);
    
                              
                               

    }
  
 
 
        if (this.textFlow && this.textFlow.type === ROUTE_TYPES.ROUTE_GROUP) {
      this.selectedGroup = this.groups.find((group) => group.id === this.textFlow.toGroup.id);
  
      
    console.log(this.type)
      this.type = "group"   
   
   
   
      this.$emit('setsgroup', this.selectedgroup );
    }

                      console.log("ss")
   if(this.textFlow)
 
  {
       if (!this.textFlow.user_id) {

      if(!this.textFlow.group_id)
      {
        if (!this.textFlow.keyword_routing)               
        {
          this.type = "noassign"
        }
        


      }

      
    }
    
                             this.type = "" 
  }
 



  
  },
  methods: {
    /**
     * SMS Routing target selection
     * @param person {object} - target object
     */
    selectPerson(person = {}) {
       this.$emit('setsUsers', person);
      return (this.selectedPerson = person);
    },
    /**
     * "Next" button click
     * @returns {Promise<void>}
     */
    async submitSMSRouting() {
      try {
        // disable button
        this.isLoading = true;
        await this.$store.dispatch('onboarding/setTextFlow', {
          type: ROUTE_TYPES.ROUTE_PERSON,
          toPerson: this.selectedPerson
        });

        // send mutation request if different user is selected
        await this.$apollo.mutate({
          mutation: M_SET_TEXT_FLOW_TO_PERSON,
          variables: {
            phoneNumberId: this.phoneId,
            userId: this.selectedPerson.id
          }
        });

        await this.$apollo.mutate({
          mutation: M_ONBOARDING_STEP,
          variables: {
            user_id: this.user.id,
            onboarding_step: 5
          }
        });
        await this.$store.dispatch('onboarding/setOnboardingStep', 5);
        // enable the Next button
        this.isLoading = false;

        return await this.$router.push('/onboarding-mobile');
      } catch (error) {
        this.isLoading = false;
        return console.log('SMS ROUTING -> USERS: ERROR\n', error);
      }
    },
        setsTypes (type)
    {
        this.$emit('setsTypes', type );
                this.type = type




    },
     setsgroup (data)
    {
        this.$emit('setsgroup', data );      
        this.selectedPerson = null;
        this.selectedgroup = data;
        console.log(this.selectedgroup) 
    },

  }
};
</script>
